import Model from './Model';

export default class Note extends Model {
    author;
    note;
    date;

    toJson() {
        return {
            ...this,
            visible_counselor: true,
            visible_client: !!this.visible_client,
            visible_employer: !!this.visible_employer
        };
    }

}



// WEBPACK FOOTER //
// ./src/models/Note.js